import { motion } from "framer-motion";
import { FileCheck2 } from "lucide-react";
import { useSettings } from "@/lib/SettingsContext";

const EASE = [0.16, 1, 0.3, 1];

export default function PriceList() {
  const settings = useSettings();
  const rows = [...(settings.services || []), ...(settings.extras || [])];

  return (
    <section id="price-list" data-testid="price-list-section" className="bg-[#F3EFEA] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="lg:col-span-5"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-[#1B523F]">
            No Surprises
          </p>
          <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-[#121A16] sm:text-5xl">
            A simple,
            <br />
            <em className="italic text-[#0F382A]">honest price list.</em>
          </h2>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-[#4A5A52]">
            Every job starts with a free site visit and finishes with a
            professional invoice and receipt. Weekly and monthly contracts
            available for homes and businesses.
          </p>
          <div className="mt-8 flex items-center gap-3 rounded-2xl border border-[#E5DEC3] bg-[#FAF8F5] px-6 py-4">
            <FileCheck2 className="h-5 w-5 shrink-0 text-[#D4AF37]" strokeWidth={1.75} />
            <p className="text-sm text-[#4A5A52]">
              <span className="font-semibold text-[#0F382A]">Invoice & receipt</span> provided
              with every job — ideal for landlords and businesses.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.12, ease: EASE }}
          className="lg:col-span-7"
        >
          <div className="overflow-hidden rounded-[1.75rem] border border-[#E5DEC3] bg-[#FAF8F5]">
            {rows.map((r, i) => (
              <div
                key={r.id || r.name}
                data-testid={`price-row-${r.id || i}`}
                className={`group flex items-baseline justify-between gap-6 px-8 py-5 transition-colors duration-300 hover:bg-[#F4ECE1] ${
                  i !== rows.length - 1 ? "border-b border-[#E5DEC3]" : ""
                }`}
              >
                <span className="font-serif text-xl font-light text-[#121A16] lg:text-2xl">{r.name}</span>
                <span aria-hidden className="mx-2 flex-1 border-b border-dotted border-[#4A5A52]/30" />
                <span className="whitespace-nowrap font-mono text-sm font-medium text-[#1B523F]">
                  {r.price_label}
                </span>
              </div>
            ))}
          </div>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#4A5A52]">
            Final quote confirmed after your free site visit
          </p>
        </motion.div>
      </div>
    </section>
  );
}
